import React from "react";

import { useSearchspringPage } from "@app/hooks/use-searchspring-page";

import { Icon } from "@app/components/icon";

export function ResultFooter() {
  const { handleNextPage, isLastPage, pagination } = useSearchspringPage();

  if (!pagination) return null;

  return (
    <div className="flex flex-col items-center gap-6 px-4 pb-16 pt-6 md:px-8 md:pb-24 md:pt-16">
      <button
        onClick={handleNextPage}
        className="btn btn-md btn-outline-light disabled:pointer-events-none"
        disabled={isLastPage}
      >
        <Icon className="size-4" id="Plus" />
        <span>Load more products</span>
      </button>
      <p className="sh1 text-neutrals-grey-2">
        Shows {pagination.end} / {pagination.totalResults} products
      </p>
    </div>
  );
}
